import React from "react";
import { useAuthContext } from "shared/context/auth-context";
import CustomerRoutes from "customer/customer-routes";
import AuthRoutes from "auth/auth-routes";
import _ from "lodash";

function AppRoutes() {
  const [{ user }] = useAuthContext();
  if (!_.isEmpty(user)) return <CustomerRoutes />;
  return  <AuthRoutes />;
}

export default AppRoutes;
